import * as React from 'react'
import { FC } from 'react'
import Receipts from './recepts'
import { Filters } from '../../../../../types/strapi/strapi'

interface ReceptsConfigProps {
    config: string
}

const ReceptsConfig: FC<ReceptsConfigProps> = ({ config }) => {
    return config === 'Ожидаемые' ? (
        <Receipts
            receiptStatusFilters={['Создан', 'Прибыл', 'В приемке']}
            positionFilters={{ positionStatus: { $eq: 'Ожидается' } }}
            sort={['receipt.createdAt:asc']}
            actions
        />
    ) : (
        <Receipts
            receiptStatusFilters={['В приемке', 'Завершен', 'Отменен']}
            positionFilters={
                {
                    $or: [
                        { positionStatus: { $eq: 'Принята' } },
                        { receipt: { receiptStatus: { $eq: 'Отменен' } } },
                    ],
                } as Filters
            }
        />
    )
}

export default ReceptsConfig
